export const routerLocales = {
  'en-US': 'en-US',
  'en-CA': 'en-CA',
  'fr-CA': 'fr-CA',
  'pt-BR': 'pt-BR',
  'es-MX': 'es-MX',
  'es-419': 'es-419',
};
